import React from "react";
import { useQuoteContext } from "../../../context-api/quote-context";
import { Link } from "react-router-dom";
import { useNavContext } from "../../../context-api/nav-context";
import { propertyTypeData } from "../utils/propertyTypeData";

const QuestFive = () => {
  const { propertyClick } = useQuoteContext();
  const { closeNavbarMenu } = useNavContext();
  return (
    <section
      className="questions-section section-wrapper"
      onMouseOver={closeNavbarMenu}
    >
      <div className="question-header">
        <h1 className="quote-question-title">
          Which of these best describes your home?
        </h1>
      </div>
      <div className="question-card-section">
        {propertyTypeData.map((item, index) => {
          const { title, image } = item;
          return (
            <Link
              className="question_link"
              key={index}
              to="/question-six"
              onClick={() => propertyClick(title)}
            >
              <div className="question-card">
                <div className="question-card-img">
                  <img src={image} alt={title} />
                </div>
                <div className="question-card-text">
                  <h5 className="subtitle question_subtitle">{title}</h5>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
};

export default QuestFive;
